import { CustomerMetafields } from "~/types"
import SetupMobileHeader from "../../../../../setup/components/SetupMobileHeader.client"

type MobileHeaderProps = {
    openMenu: () => void,
    openCart: () => void,
    customer?: CustomerMetafields,
}

export default function CustomMobileHeader({ openMenu, openCart, customer }: MobileHeaderProps) {

    return (
        <>
            <header role="banner" className="headerResponsive flex lg:hidden items-center h-nav backdrop-blur-lg z-40 top-0 justify-between w-full leading-none gap-4 px-4 md:px-8">
                <SetupMobileHeader openCart={openCart} openMenu={openMenu} customer={customer} />
            </header>

        </>
    )
}